import { defineMessages } from 'react-intl';

export default defineMessages({
  validationButtonTitle: {
    id: 'assignment_dialog.validation_button',
  },
  validationSuccessMessage: {
    id: 'validation_drawer.validation_success_message',
  },
  editWarningMessage: {
    id: 'claim_rejected.edit_warning_message',
  },
  editProvisionIntervenant: {
    id: 'edit_provision_intervenant_message',
  },
  errorLockedClaim: {
    id: 'error.claim_is_locked_error',
  },
  FeeNoteTitle: {
    id: 'side_bar.fee_note',
  },
  provisionTab: {
    id: 'court_manager_legal_proceedings_page.provision_tab.title',
  },
  courtManagerRecapTitle: {
    id: 'court_manager_legal_proceedings_page.recap_tab.title',
  },
  victimExcludedFromCoverageWarningMessage: {
    id: 'victim.excluded_from_coverage_warning_message',
  },
  preOpeningPageProvisionalReferenceAlertError: {
    id: 'preopening_page.provisional_reference_alert_error',
  },
});
